module.exports = __webpack_public_path__ + "static/banner_course-96fbd6265c0af392897e3bb1f464130b.png";